import useCurrentUser from '../../hooks/useCurrentUser'

export default function MyTrainer(){
	const {trainer_data} = useCurrentUser()
	const {trainer_bio:bio} = trainer_data
	console.log(trainer_data)
	return (
		<div className="d-flex justify-content-center py-5">
			<div>
				<div className="text-center">
					<strong>
						{trainer_data.user_name}
					</strong>
				</div>
				{Boolean(bio.img)&&
					<img 
						style={{
							display:'block',
							height:'300px',
							width:'300px',
							objectFit:'cover',
							borderRadius:'16px'
						}}
						src={bio.img}
					/>
				}
				<div>
					<strong>Phone:</strong>  {trainer_data.phone}
				</div>
				<div>
					<strong>Email:</strong> {trainer_data.email}
				</div>
				{Boolean(bio.bio)&&
					<div className="mt-2">
						<strong>General Info</strong>
						<hr className="my-1"/>
						<div style={{whiteSpace:'pre-line'}}>
							{bio.bio}
						</div>
					</div>
				}
				{Boolean(bio.specialty)&&
					<div className="mt-2">
						<strong>Specialties</strong>
						<hr className="my-1"/>
						<div style={{whiteSpace:'pre-line'}}>
							{bio.specialty}
						</div>
					</div>
				}
				{Boolean(bio.certifications)&&
					<div className="mt-2">
						<strong>Certifications</strong>
						<hr className="my-1"/>
						<div style={{whiteSpace:'pre-line'}}>
							{bio.certifications}
						</div>
					</div>
				}
			</div>
		</div>
	)
}